/*
 * Ziti runtime configuration.
 *
 * Copyright (c) 2020-2021 Dev Null Productions -  All Rights Reserved
 */

// URI refrenced in emails and user communication
const _uri = "http://localhost:8080";
//const _uri = "https://blocktr.ac"
//const _uri = "https://zerptracker.com";
//const _uri = "https://stracker.io";

// API identifier, used to load certs
const _api_id = "localhost"
//const _api_id = "apiblocktrac";
//const _api_id = "apizerptrackercom";
//const _api_id = "apistrackerio";

module.exports = {
  // Log params
  logfile  : "ziti.log",
  loglevel : "verbose",
  logtest  : false, // if true log messages will be displayed when running tests

  // App URI (see above)
  uri : _uri,

  // API ID (see above)
  api_id : _api_id,

  // Host portion of app URI
  host : new URL(_uri).host,

  // Ports application listens on
  http_port  : 3000,
  https_port : 3001,

  // Minimum password score we'll accept
  min_password_score : 3,

  // Maximum jsonpath complexity we'll accept
  max_jsonpath_complexity : {
      unary : 5,
     binary : 10,
    logical : 5
  },

  // Max JSONPath length
  max_jsonpath_length : 1000,

  // In milliseconds:
  timeouts : {
                      auth : 3600000,   // 1 hour
              registration : 259200000, // 3 days
            password_reset : 3600000,   // 1 hour
                   request : 20000,     // 20 seconds
         filter_expression : 1000,      // 1 second
              filter_cache : 30000,     // 30 seconds
    cleanup_filter_tallies : 60000,     // 1 minute
                  db_query : 3000       // 3 seconds
  },

  // Number of days before renewal to email user
  renewal_reminder_days : 3,

  // Number of matches to retain per filter
  filter_match_history : 100,

  // Number of days to retain notifications
  notification_retention_days : 5,

  // Number of days to retain log records
  log_retention_days : 14,

  // Acceptable values for user.membership_level
  membership_levels : [
    'basic',
    'standard',
    'premium'
  ],

  // Initial / default membership_level on user registration
  default_membership_level : 'basic',

  // Options presented to user when selecting plan,
  // used to determine cost and renewal_date
  membership_months : [1, 3, 6, 12],

  // Used to set intial / default renewal_date on user registration
  default_renewal_months : 1,

  // Initial profile assigned to user
  initial_profile : {
    batch_size : 15,
    notification_time : 15
  },

  // Features specific to each membership_level
  membership_features : {
    'basic' : {
      cost : 0,
      monthly_costs : {
         3 : 0,
         6 : 0,
        12 : 0
      },
      filters : 3,
      sinks : 1,
      sinks_per_filter : 1,
      advanced_sinks : false,
      batch_sizes : [10, 15, 20, 25],
      notification_times : [15, 30, 60]
    },

    'standard' : {
      cost : 7.99,
      monthly_costs : {
         3 : 19.99,
         6 : 38.99,
        12 : 75.99
      },
      filters : 10,
      sinks : 5,
      sinks_per_filter : 1,
      advanced_sinks : true,
      batch_sizes : [5, 10, 15, 20, 25, 50],
      notification_times : [5, 10, 15, 30, 60]
    },

    'premium' : {
      cost : 14.99,
      monthly_costs : {
         3 : 38.99,
         6 : 74.99,
        12 : 145.99
      },
      filters : 25,
      sinks : 5,
      sinks_per_filter : 5,
      advanced_sinks : true,
      batch_sizes : [1, 5, 10, 15, 20, 25, 50, 100],
      notification_times : [0, 1, 5, 10, 15, 30, 60]
    }
  },

  // Maximum number of additions user can add to their account
  max_additions : {
    filters : 5,
      sinks : 10
  },

  // Cost of each additional
  additions_cost : {
    filters : 3,
    sinks : 1
  },

  // Hard limits to filter matches
  filter_interval_cap : 10,

  // Filter match cap interval length (in ms)
  filter_interval_length : 60000, // 60000 = 1 minute

  // Hard limits to notifications from sink type
  monthly_sink_caps : {
    sms : 50
  },

  // Requests configuration
  requests : {
    default_transactions : 50, // number of transactions retrieved by default
        max_transactions : 100 // max number of transactions able to be retrieved
  },

  ///

  // Number of subworkers launched by each worker
  workers : {
     run_filters : 3,
    notify_sinks : 3,
           maint : 7
  },

  // Time workers sleep between operations (in ms)
  worker_delays : {
            listen_to_txs : 1000,    // 1 second
                heartbeat : 10000,   // 10 seconds - heartbeat

              run_filters : 500,     // 0.5 seconds
              cleanup_txs : 600000,  // 10 minutes
          cleanup_filters : 600000,  // 10 minutes

             notify_sinks : 500,     // 0.5 seconds
          cleanup_matches : 3600000, // 1 hour
    cleanup_notifications : 3600000, // 1 hour

                   maint  : 1000,    // 1 second
                   outage : 3600000  // 1 hour
  },

  // Seconds after which an outage is reported (in ms)
  outage_timeouts : {
             listen_to_txs : 600000,  // 10 minutes

               run_filters : 5000,    // 5 seconds
      cleanup_transactions : 660000,  // 11 minutes
    cleanup_filter_tallies : 80000,   // 1 minute 20 seconds

             notify_sinks : 5000,    // 5 seconds
           cleanup_matches : 4500000, // 1 hour 15 minutes
     cleanup_notifications : 4500000, // 1 hour 15 minutes

            register_users : 3000,    // 3 seconds
           reset_passwords : 3000,    // 3 seconds
                   billing : 3000,    // 3 seconds
          reset_privileges : 3000,    // 3 seconds
            notify_outages : 4500000, // 1 hour 15 minutes
              cleanup_logs : 60000    // 1 minute
  },

  // Other thresholds which outages are reported
  outage_thresholds : {
               block_difference : 1,
              txs_not_processed : 100,
    filter_matches_not_notified : 200
  },

  // Maximum number of specified target the
  // specified worker will try to process at a time
  max_worker_targets : {
    run_filters :  {
      txs : 250
    },

    notify_sinks : {
      matches : 1000,
      filters : 50
    }
  }
}
